import { Utils } from '@/common/Utils';
import { Typography } from '@mui/material';
import { WithLocaleProps } from '../../providers/LocaleProvider';
import { KLAYO_COLORS } from '../../themes';
import type { BaseTableRow, TableProps } from '../../types/components/table.types';
import { Table } from './Table';

export interface LearningHistoryRow extends BaseTableRow {
  id: string;
  /** ISO date — sorted chronologically by the grid (ISO strings sort lexically = chronologically). */
  date: string;
  /** Pre-translated event description (see LearningHistoryDialog.describeEvent). */
  details: string;
}

interface LearningHistoryTableProps
  extends TableProps<LearningHistoryRow>,
    Partial<WithLocaleProps> {}

export class LearningHistoryTable extends Table<LearningHistoryRow, LearningHistoryTableProps> {
  static columns = {
    date: { field: 'date', label: 'manage.learningHistory.date' },
    details: { field: 'details', label: 'manage.learningHistory.details' },
  };

  static defaultProps = {
    ...Table.defaultProps,
    columns: [],
    noRowsMessage: '',
  };

  getRowId(e: LearningHistoryRow): string {
    return this.tableId + '_' + e.id;
  }

  initColumns(): void {
    const { columns, sortable, translate } = this.props;

    this.columns = [];

    columns?.forEach((c) => {
      if (!this.hasColumn(c)) return;

      if (c.type === LearningHistoryTable.columns.date) {
        this.columns.push({
          field: c.field || LearningHistoryTable.columns.date.field,
          headerName: translate?.(LearningHistoryTable.columns.date.label),
          sortable: sortable,
          filterable: false,
          disableReorder: true,
          width: 180,
          valueGetter: (_value, row) => row.date,
          renderCell: (params) => (
            <Typography variant='body2' color={KLAYO_COLORS.GreyGR900}>
              {params.row.date ? Utils.formatDateWithoutToday(params.row.date) : ''}
            </Typography>
          ),
        });
      }

      if (c.type === LearningHistoryTable.columns.details) {
        this.columns.push({
          field: c.field || LearningHistoryTable.columns.details.field,
          headerName: translate?.(LearningHistoryTable.columns.details.label),
          sortable: false,
          filterable: false,
          disableReorder: true,
          flex: 1,
          valueGetter: (_value, row) => row.details,
          renderCell: (params) => (
            <Typography variant='body2' color={KLAYO_COLORS.GreyGR900}>
              {params.row.details}
            </Typography>
          ),
        });
      }
    });
  }
}
